import { Option } from "../models";

export const reactSelectFilterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    stringify: (option: Option) => `${option.label}`,
    matchFrom: 'any' as const,
    trim: true,
};
